module.exports = __webpack_public_path__ + "static/praga-1-c7d281a4dab23b6dedd8120288e509d4.jpg";